import { render, staticRenderFns } from "./PlanTab.vue?vue&type=template&id=cfd4059a&"
import script from "./PlanTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PlanTab.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PlanTab.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports